import useStandardDetailDataState from '../../hooks/ui-handlers/use-standard-detail-data-state.hook';
import useStandardDetailLayoutTab from './hooks/ui-handlers/use-standard-detail-layout-tab.hook';

export default function useStandardDetailLayoutViewModel() {
  // #region Dependencies
  const { scoringStandardDetail, standardDetailLayoutParams, standardSearchState } =
    useStandardDetailDataState();
  // #endregion

  // #region Handlers
  const tab = useStandardDetailLayoutTab({
    filter: standardSearchState.state,
    partId: standardDetailLayoutParams.params?.partId,
  });
  // #endregion

  return { scoringStandardDetail, tab };
}
